import { get } from 'app/utils/axios/kheti'
import { Order, OrderAggregate } from '../models/orders'
import { API } from '../models/api'

interface Response extends API<Order> {
  orders_aggregate: OrderAggregate
}

interface FetchFarmerOrdersParams {
  farmerId: string
  page?: number
  limit?: number
  start_date?: string
  end_date?: string
  search_query?: string
  order_type?: string
}

const fetchFarmerOrders = async ({
  farmerId,
  page,
  limit = 10,
  start_date,
  end_date,
  search_query,
  order_type,
}: FetchFarmerOrdersParams) => {
  try {
    const params = new URLSearchParams()

    const hasFilters = !!(start_date || end_date || search_query || order_type)

    if (!hasFilters && page) params.append('page', String(page))
    if (!hasFilters && limit) params.append('limit', String(limit))

    if (start_date) params.append('start_date', start_date)
    if (end_date) params.append('end_date', end_date)
    if (search_query) params.append('search_query', search_query)
    if (order_type) params.append('order_type', order_type)

    const url = `/farmer-360/v1/farmer/${farmerId}/orders?${params.toString()}`

    return await get<Response>(url)
  } catch (e) {
    return null
  }
}

export default fetchFarmerOrders
